function engravingInputs() {
  return document.querySelectorAll('#personalize-options input');
}
var noEngravingRequired = false

function addErrorMessage(engravingInputField, hasEngravingDetails) {
  var errorMessageContainers = engravingInputField.parentNode.querySelectorAll('.personalization-error-message');
  
  // Remove existing error message(s)
  if (errorMessageContainers.length > 0) {
    errorMessageContainers.forEach(function(errorMessageContainer) {
      errorMessageContainer.remove();
    });
  }
  
  // Check if the input is empty
  if (!noEngravingRequired && !hasEngravingDetails) {
    // Create a new error message element
    var errorMessage = document.createElement('div');
    errorMessage.className = 'personalization-error-message';
    errorMessage.textContent = 'Engraving details are missing. Please provide the desired letter(s)/number(s) for engraving.';

    // Append the error message below the input field
    engravingInputField.parentNode.appendChild(errorMessage);
  }
}

function checkAllEngravingDetails () {
  var hasEngravingDetails = true;
  engravingInputs().forEach(function(engravingInput) {
    var engravingText = null

    // Check if input is for adding engraving or opting out of engraving
    if (engravingInput.type === "text") {
      engravingText = engravingInput.value.trim();
      // Disable checkout buttons if one engraving text is missing
      if (!engravingText) {
        hasEngravingDetails = false;
      } else {
        noEngravingCheckbox = document.getElementById('no-personalization-engraving');
        if (noEngravingCheckbox && noEngravingCheckbox.checked) {
          noEngravingCheckbox.checked = false;
          noEngravingRequired = false;
        }
      }
    }
    
  });
  
  return hasEngravingDetails;
}

function toggleHighlight() {
  engravingInputs().forEach(function(engravingInput) {
    if (engravingInput.type === "text") {
      addErrorMessage(engravingInput, !!engravingInput.value.trim());
      if (!!engravingInput.value.trim() || noEngravingRequired) {
          engravingInput.classList.remove('highlight-empty');
      } else {
        if (!noEngravingRequired) {
          engravingInput.classList.add('highlight-empty');
        }
      }      
    }    
  });    
}

function updateButtonStatus() {
  // Check if all engraving input fields have data
  var hasEngravingDetails = checkAllEngravingDetails();

  if (noEngravingRequired) {
    hasEngravingDetails = true;
  }
  
  var count = 0;
  document.querySelectorAll('.product-form__controls-group--submit button').forEach(function(buyButton) {
    // Add overlay if not exixts to allow click event
    var isOverlayAdded = buyButton.getAttribute('data-overlay-added') === 'true';
              
    if (!isOverlayAdded) {
      var overlay = document.createElement('div');
      overlay.classList.add('buy_button_overlay');
      if (buyButton.parentNode) {
        // Append the overlay to the button's parent container
        buyButton.parentNode.appendChild(overlay);
        
        // Make parent relative because overlay is absolute
        buyButton.parentNode.style.position = 'relative';
      }
      
      // Add event listener for adding value to input
      overlay.addEventListener('click', function() {
        // Your overlay click event logic goes here
        if (!hasEngravingDetails) {
          document.getElementById('personalize-options').scrollIntoView({ behavior: 'smooth' });
          toggleHighlight();
        }
      });
      buyButton.setAttribute('data-overlay-added', 'true');
    }
    
    if (hasEngravingDetails) {
      buyButton.disabled = false;
    } else {
      buyButton.disabled = true;
    }

    // toggle overlay if exists
    if (buyButton.parentNode) {
      buyButton.parentNode.querySelectorAll('.buy_button_overlay').forEach(function(overlay) {
        if (hasEngravingDetails) {
          overlay.style.display = 'none';
        } else {
          overlay.style.display = 'block';
        }  
      })
      
    }
  });   
}

function onInputChange(e) {
  addErrorMessage(e, !!e.value.trim())
  // Update the button status based on the input field value
  updateButtonStatus();

   if (!!e.value.trim()) {
     e.classList.remove('highlight-empty');
   } else {
     e.classList.add('highlight-empty');
   }
}

function onCheck(e) {
  if (e.checked) {
    // Allow no engraving 
    noEngravingRequired = true;
  } else {
    noEngravingRequired = false;
  }
  updateButtonStatus();
  engravingInputs().forEach(function() {
      toggleHighlight();
  });
}

updateButtonStatus();

document.addEventListener("quickview:loaded", function () {
  updateButtonStatus();
});